import React from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';

import { config } from '@config/pendo.config.json';
import { NvTooltip } from 'shared/components/nv-tooltip';
import { genAIGradientType1, gray1 } from 'styles/global_defaults/colors';
import { openSans, semiBoldFontWeight, textSmallFontSize } from 'styles/global_defaults/fonts';
import { halfSpacing, largeSpacing, quarterSpacing } from 'styles/global_defaults/scaffolding';

type Props = {
  variant: 'admin-only' | 'learner';
  courseAliases: Record<string, any>;
};

const styles = css`
  display: inline-block;
  padding: ${quarterSpacing}px;
  border-radius: ${quarterSpacing}px;
  background: ${genAIGradientType1};
  font-family: ${openSans};
  font-weight: ${semiBoldFontWeight};
  font-size: ${textSmallFontSize}px;
  color: ${gray1};
  white-space: nowrap;
  margin: ${halfSpacing}px ${largeSpacing}px;
`;

const VisibilityBadge: React.FC<Props> = ({ variant, courseAliases }) => {
  const isLearner = variant === 'learner';
  const dataQa = config.pendo.submissionView.aiInsights.visibilityTag;

  const label = isLearner
    ? t.SUBMISSIONS.AI_ASSIGNMENT.TAG_LEARNER(courseAliases)
    : t.SUBMISSIONS.AI_ASSIGNMENT.TAG();

  const tooltip = isLearner
    ? t.SUBMISSIONS.AI_ASSIGNMENT.TAG_TOOLTIP_LEARNER(courseAliases)
    : t.SUBMISSIONS.AI_ASSIGNMENT.TAG_TOOLTIP(courseAliases);

  return (
    <div css={css`display: flex; padding: ${halfSpacing}px 0;`}>
      <NvTooltip text={tooltip} placement='top'>
        <span css={styles} data-qa={dataQa}>
          {label}
        </span>
      </NvTooltip>
    </div>
  );
};

export default VisibilityBadge;
